import times from 'lodash/times';
import {useMemo} from 'react';
import AspectRatioBox from './AspectRatioBox';
import ICON_KAKAO_WEBTOON_LIGHT from '../../../public/static/v4/common/icon-kakao-webtoon-light.svg';
import ICON_KAKAO_WEBTOON from '../../../public/static/v4/common/icon-kakao-webtoon.svg';
import {DEFAULT_ASPECT_RATIO} from '../constant';
import useTheme from '../hook/useTheme';

interface IProps {
  childrenCount: number;
  divisionCount: number;
  className?: string;
}

export default function EmptyContentCardListV4({
  childrenCount,
  divisionCount,
  className,
}: IProps) {
  const {isLightMode} = useTheme();
  const emptyContentCardCount = useMemo(
    () =>
      divisionCount -
      (childrenCount % divisionCount) +
      // 최소 2줄은 보여주기 위해
      // childrenCount가 divisionCount보다 작을 경우 divisionCount를 더해줍니다.
      (childrenCount < divisionCount ? divisionCount : 0),
    [childrenCount, divisionCount]
  );

  if (
    // 최소 2줄은 보여주기 위해, childrenCount가 divisionCount보다 작은 경우에는
    // emptyContentCardCount가 divisionCount와 같더라도 빈 카드를 보여줍니다.
    childrenCount > divisionCount &&
    emptyContentCardCount === divisionCount
  ) {
    return null;
  }

  return (
    <>
      {times(emptyContentCardCount, index => (
        <div key={index} className={className}>
          <AspectRatioBox
            aspectRatio={DEFAULT_ASPECT_RATIO}
            className="rounded-8"
            wrapperClassName="flex-center"
            bgClassName="bg-grey-02"
          >
            <img
              src={isLightMode ? ICON_KAKAO_WEBTOON_LIGHT : ICON_KAKAO_WEBTOON}
              alt=""
            />
          </AspectRatioBox>
        </div>
      ))}
    </>
  );
}
